import { Typography } from '@euler/app/components/typography';
import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiUploadStatus, BiUploadView } from '@euler/model/bi/upload';
import { memo } from 'react';
import { View } from 'react-native';
import { biSheetTitle } from './functions/biUploadLabels';
import {
  biUploadExpiredText,
  biUploadFailureText,
} from './functions/biUploadPhase';
import { biSheetStepText } from './functions/biUploadSubtitle';

/**
 * An older card of the upload: where it stands, in a line per sheet. The
 * newest card of the upload is the one to act in.
 */
export const UploadSummary = memo(({ view }: { view: BiUploadView }) => {
  const { rpx } = useResponsiveContext();
  const chosen = view.sheets.flatMap(sheet =>
    sheet.upload ? [{ name: sheet.name, upload: sheet.upload }] : [],
  );
  if (view.status === BiUploadStatus.Failed)
    return (
      <CardNotice tone="danger" text={biUploadFailureText(view.failure)} />
    );
  if (view.status === BiUploadStatus.Expired)
    return <CardNotice text={biUploadExpiredText(view)} />;
  if (!chosen.length)
    return (
      <CardNotice
        text={
          view.status === BiUploadStatus.Uploaded
            ? '正在读取表格。'
            : '等待选择工作表，请在后面的卡片里操作。'
        }
      />
    );
  return (
    <View style={{ gap: rpx(6) }}>
      {chosen.map(({ name, upload }) => (
        <View
          key={upload.id}
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: rpx(8),
          }}
        >
          <Typography.Text
            size={rpx(13)}
            color={aiColors.foreground}
            numberOfLines={1}
            style={{ flexShrink: 1 }}
          >
            {biSheetTitle(name, view.fileName)}
          </Typography.Text>
          <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
            {biSheetStepText(upload)}
          </Typography.Text>
        </View>
      ))}
    </View>
  );
});
